import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from '@phosphor-icons/react';

import ServicePageLayout from '../layouts/ServicePageLayout';
import TestimonialCard from '../components/TestimonialCard';
import DetailedProcess from '../components/DetailedProcess';
import PlaceholderImage from '../components/PlaceholderImage';
import ServiceHero from '../components/ServiceHero/ServiceHero';
import ContactBanner from '../components/ContactBanner/ContactBanner';
import { useTranslation } from 'react-i18next';

const OnlineMarketingPage = () => {
  const { t } = useTranslation();

  const title = t('onlineMarketingPage.title');
  const subtitle = t('onlineMarketingPage.subtitle');

  const marketingFeatures = [
    { key: 'seo' },
    { key: 'ppc' },
    { key: 'content' },
    { key: 'analytics' },
  ].map(feature => ({
    title: t(`onlineMarketingPage.features.${feature.key}.title`),
    description: t(`onlineMarketingPage.features.${feature.key}.description`),
  }));

  const processSteps = [
    { key: 'analysis' },
    { key: 'strategy' },
    { key: 'implementation' },
    { key: 'optimization' },
  ].map(step => ({
    title: t(`onlineMarketingPage.process.steps.${step.key}.title`),
    description: t(`onlineMarketingPage.process.steps.${step.key}.description`),
  }));
  
  return (
    <>
      <ServiceHero title={title} subtitle={subtitle} />
      <ServicePageLayout
        title={title}
        subtitle={subtitle}
        features={marketingFeatures}
        hideHero={true}
      >
        <div className="space-y-20">
          <section className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-10 text-center">{t('onlineMarketingPage.process.title')}</h2>
            <DetailedProcess steps={processSteps} />
          </section>
        </div>

        <ContactBanner 
            title={t('onlineMarketingPage.contactBanner.title')}
            description={t('onlineMarketingPage.contactBanner.description')}
            buttonText={t('onlineMarketingPage.contactBanner.buttonText')}
            buttonLink="/contact"
        />
      </ServicePageLayout>
    </>
  );
};

export default OnlineMarketingPage;
